import type { Props } from './types';

export const ZIndex = ({ children, zIndex }: Props) => children(zIndex);
